module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/configuration-d4ef8d1db38dbb4b9085c161be12d6fa.svg";